module.exports = __webpack_public_path__ + "static/media/mastercard-logo.1d181611.jpg";